import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ConsumableService } from '../proxy/general/controllers/consumable.service';
import { GeneticMaterialService } from '../proxy/general/controllers/genetic-material.service';
import { PlantTypeService } from '../proxy/general/controllers/plant-type.service';

FieldBuilder.setNamespace('General');

export const PLANT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('plantTypeId', 'Entity.PlantType', PlantTypeService)
    .displayFromNested('plantType.name')
    .sortBy('plantType.name')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialId', 'Entity.GeneticMaterial', GeneticMaterialService)
    .required()
    .displayFromNested('geneticMaterial.name')
    .sortBy('geneticMaterial.name')
    .build(),
  FieldBuilder
    .foreignKey('consumableId', 'Entity.Consumable', ConsumableService)
    .required()
    .displayFromNested('consumable.name')
    .sortBy('consumable.name')
    .hideInChildForms()
    .build(),
];

export const PLANT_CONFIG = {
  entityName: 'Plant',
  localizationKey: 'General::Entity.Plant',
  fields: PLANT_FIELDS,
  permission: 'GeneralConsumables.Plants',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Consumables + MENU_NAME_SUFFIX,
};
